import { createContext, useContext } from "react";
import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { isNullOrUndefined } from "../extension/StringExtension";
// import { NotificationExtension } from "../extension/NotificationExtension";
import { LoginModel } from "../../model/LoginModel";
import { MessageResponse } from "../../model/MessageResponse";
import { repositorySign } from "../_const/_constVar";
import { IAuthProvider } from "../model/_base/AuthProvider";
import { ResponseLogin } from "../../model/ResponseLogin";
import { UserModel } from "../../model/UserModel";
// import { SocketExtension } from "../socket/socket";
function compressBase64(base64Str: string, maxWidth = 300, quality = 0.7) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = base64Str;
    img.onload = () => {
      const cvs = document.createElement("canvas");
      let width = img.width;
      let height = img.height;

      // Resize theo maxWidth
      if (width > maxWidth) {
        height *= maxWidth / width;
        width = maxWidth;
      }

      cvs.width = width;
      cvs.height = height;

      const ctx = cvs.getContext("2d");
      if (ctx) {
        ctx.drawImage(img, 0, 0, width, height);

        // Xuất ra base64 mới (jpeg/webp đều được)
        const newBase64 = cvs.toDataURL("image/jpeg", quality);
        resolve(newBase64);
      }
    };
  });
}

function checkBase64Size(base64Str: string, maxKB = 4500) {
  // Tính kích thước chuỗi base64 theo byte
  const sizeInBytes = (base64Str.length * 3) / 4;
  const sizeInKB = sizeInBytes / 1024;
  return sizeInKB > maxKB;
}

export const AuthProvider: IAuthProvider = {
  username: "",
  async signin(
    loginModel: LoginModel
  ): Promise<MessageResponse<ResponseLogin> | undefined> {
    let urlCreate = `/api/v1/Auth/login`;
    let callapi = await repositorySign.post<MessageResponse<ResponseLogin>>(
      urlCreate,
      loginModel
    );
    if (
      !isNullOrUndefined(callapi) &&
      !isNullOrUndefined(callapi?.data) &&
      callapi?.success === true
    ) {
      localStorage.setItem("token", callapi?.data.jwt);
      localStorage.setItem("userName", callapi?.data.userName);
      localStorage.setItem("fullName", callapi?.data.fullName);
      localStorage.setItem("empId", callapi?.data?.empId);
      localStorage.setItem("clientId", callapi?.data?.clientId);
      const response = await repositorySign.get<MessageResponse<UserModel>>(
        `/api/v1/users/detail-username?userName=${callapi.data.userName}`
      );

      if (response && response.success) {
        let result = response.data;
        try {
          if (result.avatar && result.avatar.startsWith("data:image/"))
            result.avatar = checkBase64Size(result.avatar)
              ? ((await compressBase64(result.avatar, 200, 0.6)) as string)
              : result.avatar;
        } catch (error) {
          console.error("Error fetching avatar:", error);
          result.avatar = "";
        }

        localStorage.setItem("userLogin", JSON.stringify(result));
      }
      if (callapi?.data.dateExpires)
        localStorage.setItem(
          "dateExpires",
          callapi?.data.dateExpires.toString()
        );
      AuthProvider.username = callapi?.data.userName;
      //  NotificationExtension.Success("Đăng nhập thành công !");
      // await PubNotication(callapi?.data.userName + " vừa đăng nhập !");
      // return callapi;
    }
    // if (!isNullOrEmpty(callapi?.message))
    //   NotificationExtension.Fails(callapi?.message ?? "Đăng nhập thất bại !");
    return callapi ?? undefined;
  },
  signout(): boolean {
    // SocketExtension.Disconnect();
    localStorage.setItem("token", "");
    localStorage.removeItem("dateExpires");
    localStorage.setItem("userName", "");
    localStorage.removeItem("fullName");
    localStorage.setItem("empId", "");
    localStorage.removeItem("userLogin");
    localStorage.removeItem("clientId");
    AuthProvider.username = "";
    //  await PubNotication(user + " vừa đăng xuất !");
    return !localStorage.getItem("token");
  },
  isAuthenticated(): boolean {
    // Kiểm tra xem người dùng đã đăng nhập chưa

    const _token = localStorage.getItem("token");
    const _dateString = localStorage.getItem("dateExpires");
    if (_dateString) {
      const dateExpires = new Date(_dateString);
      const _check =
        _token !== undefined &&
        _token !== null &&
        _token?.length > 10 &&
        dateExpires >= new Date();
      return _check;
    }
    return (
      _token !== undefined &&
      _token !== null &&
      _token?.length > 10 &&
      _token.split(".")?.length === 3
    );
  },
};

export function protectedLoader({ request }: LoaderFunctionArgs) {
  // If the user is not logged in and tries to access `/protected`, we redirect
  // them to `/login` with a `from` parameter that allows login to redirect back
  // to this page upon successful authentication
  if (!AuthProvider.isAuthenticated()) {
    let params = new URLSearchParams();
    params.set("callback", new URL(request.url).pathname);
    return redirect("/auth/login?" + params.toString());
  }
  return null;
}

export const authContext = createContext<boolean>(false);

export function ProvideAuth({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  const auth = useProvideAuth();
  const currentURL = window.location.pathname;
  if (!auth) {
    let params = new URLSearchParams();
    params.set("callback", currentURL);
    redirect("/auth/login?" + params.toString());
  }
  return (
    <authContext.Provider value={auth.isAuthenticated}>
      {children}
    </authContext.Provider>
  );
}

export function useAuth() {
  return useContext(authContext);
}

export function useProvideAuth() {
  const isAuthenticated = AuthProvider.isAuthenticated();
  return {
    isAuthenticated,
  };
}
